import { ref } from 'vue'
import { useUserStore } from '~/stores/user'

/**
 * 退出登录确认（Tailwind 弹窗，避免壳层按需 import ElMessageBox）。
 */
export function useLogoutConfirm(options = {}) {
  const userStore = useUserStore()
  const open = ref(false)

  function requestLogout() {
    options.onBeforeOpen?.()
    open.value = true
  }

  function cancelLogout() {
    open.value = false
  }

  async function confirmLogout() {
    open.value = false
    await userStore.logout()
  }

  return {
    logoutConfirmOpen: open,
    requestLogout,
    cancelLogout,
    confirmLogout,
  }
}
